<template>
  <div class="verify-email-container">
    <r-title class="title">{{ $t('verify.email') }}</r-title>
    <div v-if="loading">
      {{ $t('verify.email.loading') }}
      <a-spin>
        <a-icon slot="indicator" type="loading" spin />
      </a-spin>
    </div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else v-html="$t('verify.email.description')" class="verify-email-description"></div>
    <a-button type="primary" @click="goNext">{{ $t('go.home') }}</a-button>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import { mapActions } from 'vuex';
import RTitle from '@/components/common/Title.vue';
import { ROUTER_PATHS } from '@/router/constants';
import { EMAIL_VERIFIED } from '@/store/session/actionTypes';

export default {
  props: ['code'],
  components: {
    RTitle,
  },
  data() {
    return {
      loading: true,
      error: '',
    };
  },
  mounted() {
    this.loading = true;
    this.error = '';
    if (this.code) {
      firebase
        .auth()
        .applyActionCode(this.code)
        .catch((error) => {
          this.error = this.$t(error.code);
        })
        .then(() => this.emailVerified())
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    ...mapActions({
      emailVerified: EMAIL_VERIFIED,
    }),
    goNext() {
      this.$router.push(ROUTER_PATHS.ACCOUNT);
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-email-container {
  text-align: center;
}
.verify-email-description {
  text-align: left;
}
</style>
